import { ClickAwayListener } from "@mui/material";
import { useState } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import Style from "./PopOver.module.css";
import { mergeClass } from "../../../resources/utils/helper";

export default function PopOver({
  popover = [],
  onClick = () => {},
  children = null,
}) {
  const [show, setShow] = useState(false);

  const overlayPopover = (
    <div className={Style?.overlayPopover}>
      <ClickAwayListener onClickAway={() => setShow(false)}>
        <Popover id="popover-basic">
          <ul className={mergeClass(Style.overlay, "m-0 p-0")}>
            {Array.isArray(popover) && popover.length > 0 ? (
              popover.map((item, index) => (
                <li
                  key={index}
                  className={mergeClass(Style.overlayLink, "")}
                  onClick={() => {
                    onClick(item?.label);
                    setShow(false);
                  }}
                >
                  <span className={mergeClass("fs-16")}>{item.label}</span>
                </li>
              ))
            ) : (
              <li>No options available</li>
            )}
          </ul>
        </Popover>
      </ClickAwayListener>
    </div>
  );

  return (
    <div>
      <OverlayTrigger
        trigger="click"
        placement="bottom-start"
        overlay={overlayPopover}
        show={show}
        onToggle={() => setShow(!show)}
      >
        <div onClick={() => setShow(true)}>
          {children ? (
            children
          ) : (
            <HiOutlineDotsHorizontal fontSize={24} className="cursor-pointer" />
          )}
        </div>
      </OverlayTrigger>
    </div>
  );
}
